import { SearchTermsContentV2 } from "@/components/search-terms/SearchTermsContentV2";
import type { SearchTermSet } from "@/types/search-term";

interface PublicSearchTermSetViewProps {
  payload: SearchTermSet;
}

export function PublicSearchTermSetView({ payload }: PublicSearchTermSetViewProps) {
  return <SearchTermsContentV2 isPublic publicSet={payload} />;
}
